import { ClipboardList } from 'lucide-react';

export function TasksView() {
  return (
    <div className="flex flex-col items-center justify-center h-full p-sd-4 text-center bg-sd-background">
      <div className="w-14 h-14 rounded-sd-xl bg-sd-warning/10 flex items-center justify-center mb-sd-4 sd-reveal-1">
        <ClipboardList size={28} className="text-sd-warning/60" />
      </div>
      <h2 className="text-sd-xl font-bold text-sd-text mb-sd-2 sd-reveal-2">Tasks</h2>
      <p className="text-sd-base text-sd-text-secondary mb-sd-2 sd-reveal-3">Coming Soon</p>
      <p className="text-sd-sm text-sd-text-muted max-w-sm sd-reveal-3">
        Task management will let agents organize, track, and execute multi-step workflows autonomously.
      </p>
    </div>
  );
}
